import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes, { any } from 'prop-types';
import styles from './EventQuestion.scss';

import { CheckBox } from '../../../Form';
import { eventQuestionTypes as eventQuestionTypeValues, usapDefaultDescription, eventQuestionTypeIds } from '../../../../utils/eventConstants';
import Img from '../../../Img';

const EventQuestion = (props) => {
    const {
        isTemplate,
        formApi,
        index,
        question,
        onEditQuestion,
        isFlexLeagueEvent,
    } = props;

    const {
        text,
        type,
    } = question || {};

    const coreUI = useSelector(({ coreUI }) => coreUI);
    const { eventQuestionTypes } = coreUI.types.tms;
    const showDescription = parseInt(type) === eventQuestionTypeIds.THIRDPARTY_ID ? usapDefaultDescription : '';
    const intToChar = (int) => {
        const code = 'A'.charCodeAt(0);
        return String.fromCharCode(code + int);
    };

    const eventQuestionTypesDoNotAllowEditing = [
        eventQuestionTypeValues.PHONE,
        eventQuestionTypeValues.EMAIL,
        eventQuestionTypeValues.THIRDPARTY_ID,
    ];
    const eventQuestionTypeIdsDoNotAllowEditing = eventQuestionTypes
        .filter(questionType => eventQuestionTypesDoNotAllowEditing.includes(questionType.value))
        .map(questionType => {
            return questionType.id;
        });

    const disableEditing = !isTemplate && eventQuestionTypeIdsDoNotAllowEditing.includes(parseInt(type));

    const removeEventQuestion = () => {
        formApi.removeValue('eventQuestions', index);
    };

    const editEventQuestion = () => {
        onEditQuestion(question, index);
    };

    const isUsapDefaultQuestion = (formApi, type) => {
        const isThirdPartyType = parseInt(type) === eventQuestionTypeIds.THIRDPARTY_ID;
        const hasUsapVerificationTypeId = isTemplate ? formApi?.values?.template?.hasUsapVerificationTypeId : formApi?.values?.hasUsapVerificationTypeId;
        return hasUsapVerificationTypeId && isThirdPartyType;
    };

    const isFlexLeagueDefaultQuestion = (type) => {
        const isHomeCourtType = parseInt(type) === eventQuestionTypeIds.HOME_COURT;
        return isFlexLeagueEvent && isHomeCourtType;
    };

    const showEditOption = !isUsapDefaultQuestion(formApi, type) && !isFlexLeagueDefaultQuestion(type);

    const handleShowCheckInDesk = (val, i) => {
        if (!val) {
            formApi.setValue(['eventQuestions', i, 'showAcknowledge'], false);
        }
    };
    const answerOptions = question.answer ? JSON.parse(question.answer) : [];

    return (
        <div className={styles.addQuestionModal}>
            <label className="mb10" data-testid="eventquestion.label-76">
                {`QUESTION ${index + 1}`}
            </label>
            <div className="d-flex align-items-center mb4">
                <div className="flex-1">
                    {text}
                </div>
                {showEditOption && (
                    <button
                        className="ml8 btn btn-post"
                        type="button"
                        onClick={editEventQuestion}
                        data-testid="event-edit.question.edit-btn"
                    >
                        <Img src={'/img/v3/icons/icon-pen-blue.svg'} />
                    </button>
                )}
                {!isUsapDefaultQuestion(formApi, type) && (
                    <button
                        className="ml8 btn btn-post"
                        type="button"
                        onClick={removeEventQuestion}
                        data-testid="event-edit.question.remove-btn"
                    >
                        <Img src={'/img/v3/icons/icon-trash-red.svg'} />
                    </button>
                )}
            </div>
            {answerOptions.length > 0 && (
                <div className="mb4">
                    {answerOptions.map((answer, i) => (
                        <div key={`option-${intToChar(i)}`}>
                            <label data-testid="eventquestion.label-108">{`Answer ${intToChar(i)} : ${answer.option}`}</label>
                            <br />
                        </div>
                    ))}
                </div>
            )}
            {showDescription && (
                <label className="label text-black mb4" data-testid="eventquestion.label-115">
                    {showDescription}
                </label>
            )}
            {!isUsapDefaultQuestion(formApi, type) && (
                <CheckBox
                    id={`questionRequired${index}`}
                    field={[`eventQuestions`, index, 'required']}
                    customLabel="Required"
                    disabled={disableEditing}
                    disableLabelSelect={disableEditing}
                    formGroupCssClass="mb0"
                    data-testid="event-edit.question-requireditem-checkbox"
                />
            )}
            <CheckBox
                id={`questionShowAtCheckIn${index}`}
                field={['eventQuestions', index, 'showAtCheckIn']}
                customLabel="Show response at check-in desk"
                formGroupCssClass="mb0"
                onChange={val => handleShowCheckInDesk(val, index)}
                    data-testid="event-edit.question-show-at-check-initem-checkbox"
            />
            {question.showAtCheckIn && (
                <CheckBox
                    id={`questionShowAcknowledge${index}`}
                    field={['eventQuestions', index, 'showAcknowledge']}
                    customLabel="Require check-in action"
                    formGroupCssClass="mb0"
                        data-testid="event-edit.question-show-acknowledgeitem-checkbox"
                />
            )}
        </div>
    );
};

EventQuestion.propTypes = {
    isTemplate: PropTypes.bool.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
    index: PropTypes.number.isRequired,
    question: PropTypes.objectOf({
        id: PropTypes.number,
        text: PropTypes.string,
        type: PropTypes.number,
        answer: PropTypes.string,
    }),
    onEditQuestion: PropTypes.func.isRequired,
};

EventQuestion.defaultProps = {
    question: null,
};

export default EventQuestion;
